// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1zCRK","footer":"ChangeClinic_footer__2_Y9e"};